module.exports = "input.range {\n  width: 100%;\n}\n\ninput.range:focus {\n  padding: 0;\n}\n\ninput.number:focus {\n  padding: 0;\n}\n\nspan.failed {\n  overflow: auto;\n  max-height: 400px;\n  display: block;\n  text-align: left;\n}\n\n.divide{\n  margin-top: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/import-cards-modal/import-cards-modal.component.css
// module id = ./src/app/achelos-iot/modals/import-cards-modal/import-cards-modal.component.css
// module chunks = main